<template>
  <div class="vue-pincode-input-wrapper">
    <div class="vue-pincode-input__item" v-for="(cell, index) in cells" :key="cell.key">

    <div class="vue-pincode-input__dash"  v-if="index == 2 && cells.length == 6">-</div>
    <div class="vue-pincode-input__dash"  v-if="index == 4 && cells.length == 6">-</div>
    <div class="vue-pincode-input__dash" v-if="index == 6 && cells.length == 9">-</div>
    <div class="vue-pincode-input__dash"  v-if="index == 4 && (cells.length == 8)">-</div>
    <input
      :ref="`${baseRefName}${index}`"
      v-model.trim="cell.value"
      v-bind="$attrs"
      class="vue-pincode-input form-control"
      :type="cellsInputTypes[index]"
      @focus="focusIt(index)"
      @keydown.delete="onCellErase(index, $event)"
      v-uppercase
      maxlength="1"
      :id="'pincode_'+index"
    >
  </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

const BASE_REF_NAME = 'vue-pincode-input';
const CELL_REGEXP = '^[a-zA-Z0-9]{1}$';
const DEFAULT_INPUT_TYPE = 'text';
const SECURE_INPUT_TYPE = 'password';

export default {
    name:'PincodeInput',
    props:{
     value: {
       type: String,
       required: true,
     },
     length: {
       type: Number,
       default: 4,
     },
     autofocus: {
       type: Boolean,
       default: true,
     },
     secure: {
       type: Boolean,
       default: false,
     },
     characterPreview: {
       type: Boolean,
       default: true,
     },
     charPreviewDuration: {
       type: Number,
       default: 300,
     }
    },
    data() {
        return {
          baseRefName: BASE_REF_NAME,
          focusedCellIdx: 0,
          cells: [],
          watchers: {},
          cellsInputTypes: {},
          cellChars:['','','','','',''],
        }
    },

  computed: {
    pinCodeComputed() {
      return this.cells.reduce((pin, cell) => pin.toUpperCase() + cell.value.toUpperCase(), '');
    },
  },

  watch: {
    value(value) {
      if (value) {
        this.onParentValueUpdated();
      } else {
        this.reset();
      }
    },

    length() {
      this.reset();
    },

    pinCodeComputed(val) {
      this.$emit('input', val);
    },
  },

  mounted() {
    this.init();
    this.onParentValueUpdated();

    if (this.autofocus) {
      this.$nextTick(this.focusCellByIndex);
    }
  },

  methods: {
    /* init stuff */
    difference(value1, value2) {
      var output = [];
      let i = 0;
      for(i = 0; i < value2.length; i++) {
        if(value1[i] !== value2[i]) {
          output.push(value2[i]);
        }
      }
      return output.join("");
    },

    init() {
      const inputType = this.getRelevantInputType();
      let that = this;
      for (let key = 0; key < this.length; key += 1) {
        this.setCellObject(key);
        this.setCellInputType(key, inputType);
        this.setCellWatcher(key);
      }


      setTimeout(function() {
          // maybe android workaround
          let key = 0;
          const pin0 = document.getElementById('pincode_'+0);
          if (pin0) {
                pin0.addEventListener('keydown',function(e) {
                  pin0.oldValue = pin0.value;
                });

                pin0.addEventListener('input',function(e) {
                  pin0.newValue = pin0.value;
                   var x = that.difference(pin0.oldValue, pin0.newValue)
                   that.onCellChanged(0, x.toUpperCase(), "");
                });
            ;
          }


          const pin1 = document.getElementById('pincode_'+1);
          if (pin1) {
                pin1.addEventListener('keydown',function(e) {
                  pin1.oldValue = pin1.value;
                });

                pin1.addEventListener('input',function(e) {
                  pin1.newValue = pin1.value;
                   var x = that.difference(pin1.oldValue, pin1.newValue)
                   that.onCellChanged(1, x.toUpperCase(), "");
                });
            ;
          }


          const pin2 = document.getElementById('pincode_'+2);
          if (pin2) {
                pin2.addEventListener('keydown',function(e) {
                  pin2.oldValue = pin2.value;
                });

                pin2.addEventListener('input',function(e) {
                  pin2.newValue = pin2.value;
                   var x = that.difference(pin2.oldValue, pin2.newValue)
                   that.onCellChanged(2, x.toUpperCase(), "");
                });
            ;
          }


          const pin3 = document.getElementById('pincode_'+3);
          if (pin3) {
                pin3.addEventListener('keydown',function(e) {
                  pin3.oldValue = pin3.value;
                });

                pin3.addEventListener('input',function(e) {
                  pin3.newValue = pin3.value;
                   var x = that.difference(pin3.oldValue, pin3.newValue)
                   that.onCellChanged(3, x.toUpperCase(), "");
                });
            ;
          }


          const pin4 = document.getElementById('pincode_'+4);
          if (pin4) {
                pin4.addEventListener('keydown',function(e) {
                  pin4.oldValue = pin4.value;
                });

                pin4.addEventListener('input',function(e) {
                  pin4.newValue = pin4.value;
                   var x = that.difference(pin4.oldValue, pin4.newValue)
                   that.onCellChanged(4, x.toUpperCase(), "");
                });
            ;
          }

          const pin5 = document.getElementById('pincode_'+5);
          if (pin5) {
                pin5.addEventListener('keydown',function(e) {
                  pin5.oldValue = pin5.value;
                });

                pin5.addEventListener('input',function(e) {
                  pin5.newValue = pin5.value;
                   var x = that.difference(pin5.oldValue, pin5.newValue)
                   that.onCellChanged(5, x.toUpperCase(), "");
                });
            ;
          }


      }, 100);

    },

    focusIt(index) {
      this.focusedCellIdx = index;
      // this.focusCellByIndex(index);
    },

    setCellObject(key) {
      this.$set(this.cells, key, { key, value: '' });
    },

    setCellInputType(index, inputType) {
      this.$set(this.cellsInputTypes, index, inputType);
    },

    setCellWatcher(index) {
      const watchingProperty = `cells.${index}.value`;

      this.watchers[watchingProperty] = this.$watch(
        watchingProperty,
        (newVal, oldVal) => this.onCellChanged(index, newVal.toUpperCase(), oldVal),
      );
    },

    /* handlers */

    onParentValueUpdated() {
      if (this.value.length !== this.length) {
        this.$emit('input', this.pinCodeComputed);
        return;
      }

      this.value
        .split('')
        .forEach((cell, idx) => {
          this.cells[idx].value = cell || '';
        });
    },

    onCellChanged(index, newVal, oldVal) {

      newVal = newVal.toUpperCase();
      if (!this.isTheCellValid(newVal, false)) {
        this.cells[index].value = '';
        return;
      }

      // this.focusNextCell();
      let nextIndex = index + 1;
      if (index < this.length - 1) {
        this.focusCellByIndex(nextIndex);
      } else {
        this.focusCellByIndex(index);
      }

      /* performing character preview if it's enabled */
      if (this.secure && this.characterPreview) {
        setTimeout(this.setCellInputType, this.charPreviewDuration, index);
      }
    },

    onCellErase(index, e) {
      const isThisCellFilled = this.cells[index].value.length;

      if (!isThisCellFilled) {
        this.focusPreviousCell();
        e.preventDefault();
      }
    },

    onKeyDown(e) {
      if (e.keyCode == 229) {

      } else {
        switch (e.keyCode) {
          /* left arrow key */
          case 37:
            this.focusPreviousCell();
            break;

          /* right arrow key */
          case 39:
            this.focusNextCell();
            break;

          default:
            break;
        }
      }
    },

    /* reset stuff */

    reset() {
      this.unwatchCells();
      this.init();
      this.focusCellByIndex();
    },

    unwatchCells() {
      const watchers = Object.keys(this.watchers);
      watchers.forEach(name => this.watchers[name]());
    },

    /* helpers */

    isTheCellValid(cell, allowEmpty = true) {
      if (!cell) {
        return allowEmpty ? cell === '' : false;
      }

      return !!cell.match(CELL_REGEXP);
    },

    getRelevantInputType() {
      return this.secure && !this.characterPreview
        ? SECURE_INPUT_TYPE
        : DEFAULT_INPUT_TYPE;
    },

    focusPreviousCell() {
      if (!this.focusedCellIdx) return;

      this.focusCellByIndex(this.focusedCellIdx - 1);
    },

    focusNextCell() {
      if (this.focusedCellIdx === this.length - 1) return;

      this.focusCellByIndex(this.focusedCellIdx + 1);
    },

    focusCellByIndex(index = 0) {
      const ref = `${this.baseRefName}${index}`;
      if (this.$refs[ref]) {
        const el = (this.$refs[ref])[0];
        el.focus();
        el.select();
      }

      this.focusedCellIdx = index;
    },
  },
}
</script>

<style>
.vue-pincode-input-wrapper {
  display: inline-flex;
}

.vue-pincode-input {
  margin-right: 3px;
  max-width: 40px;
}
.vue-pincode-input__item {
  display:inline-flex;
}
.vue-pincode-input__dash {
  padding:5px;
}
.vue-pincode-input:focus {
}
</style>
